import React, { useState } from "react";
import PreviewPopupTable from "./PreviewPopupTable";
import CommonLayout from "../CommonLayout";

const EditTaskAction = ({ prevData={}, newData }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [taskData, setTaskData] = useState({});
  
  // Format boolean values for display
  const formatBoolean = (value) => {
    if (value === true || value === "true") return "Pinned";
    if (value === false || value === "false") return "Unpinned";
    return value?.toString() || "-";
  };
  
  // Format data for display (convert boolean is_pinned to readable text)
  const formatTaskData = (data) => {
    if (!data) return data;
    const formatted = { ...data };
    if (formatted.is_pinned !== undefined) {
      // formatted.is_pinned = formatBoolean(formatted.is_pinned);
      formatted.is_pinned_show = formatBoolean(formatted.is_pinned);
    }
    return formatted;
  };
  
  const fieldsData = [
    { colKey: "is_pinned_show", colText: "Pin" },
    { colKey: "reference", colText: "Reference" },
    { colKey: "tags", colText: "Tags" },
    { colKey: "task", colText: "Task" },
    { colKey: "note", colText: "Note", },
    { colKey: "status", colText: "Status" },
    { colKey: "progress", colText: "Progress" },
    { colKey: "due", colText: "Due Date" },
    { colKey: "escalate", colText: "Reminder(days)" },
    { colKey: "remind", colText: "Escalate(days)" },
    { colKey: "created_on", colText: "Created On" },
    { colKey: "assigned_to", colText: "Assigned To" },
    { colKey: "owned_by", colText: "Owned By" },
  ];

  const showPopupHandler = (data) => {
    setTaskData(data);
    setShowPopup(true);
  };

  // Format previous and new data for display
  const prevFormatted = formatTaskData(newData.previusTaskInfo || {});
  const newFormatted = formatTaskData({
    ...newData,
    reference: newData.previusTaskInfo?.reference,
  });

  return (
    <>
      <CommonLayout
        prevData={prevFormatted}
        newData={newFormatted}
        fieldsData={fieldsData}
        showPopupHanldel={showPopupHandler}
      />
      {showPopup && (
        <PreviewPopupTable
          task={taskData}
          hidePopup={() => {
            setShowPopup(false);
          }}
        />
      )}
    </>
  );
};

export default EditTaskAction;
